import debounce from '@os/debounce';

export default function createKeyBuffer(opts = {}) {
	let keyPressBuffer = [];

	function clearKeyBuffer() {
		keyPressBuffer = [];
	}

	const delayClearKeyBuffer = debounce(clearKeyBuffer, opts.delay || 1000);


	return function keyBuffer(input) {
		keyPressBuffer.push(input);
		delayClearKeyBuffer();
		return keyPressBuffer;
	};
}
